import FeatureBlocks from './FeatureBlocks';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

FeatureBlocks.schema = schema;
FeatureBlocks.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default FeatureBlocks;
